export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/plane.ea73a9bb-de7ba4.svg";